import React from "react";
import "./HomePage.css";
import Footer from "../footer/Footer";
import { Button, Carousel } from "react-bootstrap";

import { checkUser } from "../../actions/userActions";
import { connect } from "react-redux";
import { InView } from "react-intersection-observer";
import ReactPlayer from "react-player/vimeo";
import NavbarClass from "../NavbarClass";
import { openSignUpModal } from "../../actions/generalActions";
import Waypoint from "./Waypoint";
import history from "../../config/history";
import { loggedInAndPremiumCheckUser } from "../../actions/userActions";
import { pageview } from "../../utils/googleAnalyticsUtils";
import { testimonialsData } from "../../utils";

class HomePage extends React.Component {
  async componentDidMount() {
    pageview("Home");
  }

  state = {
    signModalShow: false,
    priceModalShow: false,
    playHomePageVideo: false,
  };

  handleSignInClose = () => {
    this.setState({ signModalShow: false });
  };

  handleSignInOpen = () => {
    this.setState({ signModalShow: true });
  };

  handlePricingClose = () => {
    this.setState({ priceModalShow: false });
  };

  handlePricingOpen = () => {
    this.setState({ priceModalShow: true });
  };

  homeVideoPlayerRef = React.createRef();

  // isInViewport() {
  //   const el = document.querySelector("#home-page-video-container");
  //   const rect = el.getBoundingClientRect();

  //   const playHomePageVideo =
  //     rect.top >= 0 &&
  //     rect.left >= 0 &&
  //     rect.bottom <=
  //       (window.innerHeight || document.documentElement.clientHeight) &&
  //     rect.right <= (window.innerWidth || document.documentElement.clientWidth);
  //   console.log(playHomePageVideo)
  //   if (playHomePageVideo) {
  //     this.setState({ playHomePageVideo });
  //     alert("video in screen")
  //     document.removeEventListener("scroll", this.isInViewPort, {
  //       passive: true,
  //     });
  //   }
  // }

  // handleHomePageVideoPlay() {
  //   document.addEventListener("scroll", this.isInViewPort, {
  //     passive: true,
  //   });
  // }

  render() {
    return (
      <div className="hp-root">

        {/* ── HERO SECTION ── */}

        <section className="hp-hero">
          <NavbarClass
            homePageNavbar
            handleSignInOpen={this.props.handleSignInOpen}
          />
          <div className="hp-hero__bubbles" aria-hidden="true">
            {[...Array(8)].map((_, i) => (
              <span key={i} className={`hp-bubble hp-bubble--${i + 1}`} />
            ))}
          </div>
          <div className="hp-hero__content">
            <div className="hp-hero__badge">
              <span role="img" aria-label="sparkles">✨</span> A Valuetainment Platform for Kids
            </div>
            <div className="hp-hero__logo-wrap">
              <img
                width="700"
                height="293"
                className="hp-hero__logo"
                src={`${process.env.REACT_APP_AWS_IMG_CDN}/logos/Main_logo__700_292.webp`}
                alt="MeenduToons logo with colourful ice cream waffle characters"
              />
            </div>
            <p className="hp-hero__tagline">
              Where <span className="hp-hero__tagline--accent">values</span> meet{" "}
              <span className="hp-hero__tagline--accent2">entertainment</span>
            </p>
            <div className="hp-hero__ctas">
              <Button className="hp-hero__cta-primary" onClick={() => history.push("/videos")}>
                Check out Free Videos <i className="fa fa-play ml-2" />
              </Button>
            </div>
          </div>
          <div className="hp-hero__wave">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 319">
              <path
                fill="#fff"
                fillOpacity="1"
                d="M0,160L21.8,181.3C43.6,203,87,245,131,218.7C174.5,192,218,96,262,80C305.5,64,349,128,393,144C436.4,160,480,128,524,106.7C567.3,85,611,75,655,74.7C698.2,75,742,85,785,106.7C829.1,128,873,160,916,176C960,192,1004,192,1047,165.3C1090.9,139,1135,85,1178,101.3C1221.8,117,1265,203,1309,240C1352.7,277,1396,267,1418,261.3L1440,256L1440,320L1418.2,320C1396.4,320,1353,320,1309,320C1265.5,320,1222,320,1178,320C1134.5,320,1091,320,1047,320C1003.6,320,960,320,916,320C872.7,320,829,320,785,320C741.8,320,698,320,655,320C610.9,320,567,320,524,320C480,320,436,320,393,320C349.1,320,305,320,262,320C218.2,320,175,320,131,320C87.3,320,44,320,22,320L0,320Z"
              ></path>
            </svg>
          </div>
        </section>

        {/* Vision Section */}
        <section className="hp-vision">
          <div className="container">
            <InView threshold={0.2} triggerOnce>
              {({ inView, ref }) => (
                <div ref={ref} className={`text-center hp-animate hp-animate--up ${inView ? "is-visible" : ""}`}>
                  <h2 className="hp-section-heading">Our Vision</h2>
                  <div className="hp-vision__quote-card">
                    <span className="hp-vision__quote-mark">&ldquo;</span>
                    <p className="hp-vision__quote-text">
                      To make the concept of an ideal world full of moral values
                      and humanity, a reality
                    </p>
                    <span className="hp-vision__quote-mark hp-vision__quote-mark--right">&rdquo;</span>
                  </div>
                </div>
              )}
            </InView>
            <div className="hp-vision__cards row">
              <InView threshold={0.2} triggerOnce>
                {({ inView, ref }) => (
                  <div ref={ref} className={`col-12 col-xl-6 mb-4 hp-animate hp-animate--left ${inView ? "is-visible" : ""}`}>
                    <div className="hp-card">
                      <div className="hp-card__icon">💡</div>
                      <h3 className="hp-card__heading">Our Beliefs</h3>
                      <ul className="hp-vision__beliefs">
                <li>Small things make a big difference.</li>
                <li>“WE” can make the world a better place.</li>
                <li>It’s important to start early.</li>
                <li>
                  Kind children make kind adults and vice versa. It’s a virtuous
                  cycle!
                </li>
                      </ul>
                    </div>
                  </div>
                )}
              </InView>
              <InView threshold={0.2} triggerOnce>
                {({ inView, ref }) => (
                  <div ref={ref} className={`col-12 col-xl-6 mb-4 hp-animate hp-animate--right delay-2 ${inView ? "is-visible" : ""}`}>
                    <div className="hp-card">
                      <div className="hp-card__icon">🎬</div>
                      <h3 className="hp-card__heading">Why are we here</h3>
                      <div className="hp-player-wrap">
                        <div className="hp-player-ratio">

                          <ReactPlayer
                            alt="A couple on a balcony discovering the idea for MeenduToons"
                            width="100%"
                            height="100%"
                            className="hp-player"
                            controls
                            url="https://vimeo.com/818090827"
                            config={{ vimeo: { playerOptions: { playsinline: true } } }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </InView>
            </div>
          </div>
        </section>

        {/* How Section */}
        <section className="hp-how">
          <div className="hp-wave-top">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
              <path fill="#fff" fillOpacity="1" d="M0,160L26.7,133.3C53.3,107,107,53,160,69.3C213.3,85,267,171,320,197.3C373.3,224,427,192,480,160C533.3,128,587,96,640,90.7C693.3,85,747,107,800,101.3C853.3,96,907,64,960,74.7C1013.3,85,1067,139,1120,186.7C1173.3,235,1227,277,1280,261.3C1333.3,245,1387,171,1413,133.3L1440,96L1440,0L1413.3,0C1386.7,0,1333,0,1280,0C1226.7,0,1173,0,1120,0C1066.7,0,1013,0,960,0C906.7,0,853,0,800,0C746.7,0,693,0,640,0C586.7,0,533,0,480,0C426.7,0,373,0,320,0C266.7,0,213,0,160,0C106.7,0,53,0,27,0L0,0Z" />
            </svg>
          </div>
          <div className="container hp-how__inner">
            <InView threshold={0.2} triggerOnce>
              {({ inView, ref }) => (
                <div ref={ref} className={`hp-animate hp-animate--up ${inView ? "is-visible" : ""}`}>
                  <h2 className="hp-section-heading text-center">How will we do that?</h2>
                </div>
              )}
            </InView>
            <div className="row hp-how__cards">
              <InView threshold={0.15} triggerOnce>
                {({ inView, ref }) => (
                  <div ref={ref} className={`col-12 col-xl-6 hp-animate hp-animate--left ${inView ? "is-visible" : ""}`}>
                    <div className="hp-how-card">
                      <div className="hp-how-card__tag hp-how-card__tag--videos">Videos</div>
                      <h3 className="hp-how-card__heading"><strong>Instill</strong> through <strong>Videos</strong></h3>
                      <p className="hp-how-card__desc">Our Valuetainment platform brings short cartoon videos brimming with values and entertainment for your kids.</p>
                      <div className="hp-player-wrap">
                        <div className="hp-player-ratio">
                          <ReactPlayer
                            width="100%" height="100%"
                            className="hp-player"
                            controls playing={false}
                            url="https://vimeo.com/793823775"
                            config={{ vimeo: { playerOptions: { playsinline: true } } }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </InView>
              <InView threshold={0.15} triggerOnce>
                {({ inView, ref }) => (
                  <div ref={ref} className={`col-12 col-xl-6 hp-animate hp-animate--right delay-2 ${inView ? "is-visible" : ""}`}>
                    <div className="hp-how-card">
                      <div className="hp-how-card__tag hp-how-card__tag--activities">Activities</div>
                      <h3 className="hp-how-card__heading"><strong>Implement</strong> through <strong>Activities</strong></h3>
                      <p className="hp-how-card__desc">A world of unique value-based stories for kids and exciting activities designed for parent-child bonding.</p>
                      <div className="hp-story-iframe-wrap">
                        <div className="hp-story-iframe-ratio">
                          <iframe
                            src={`${process.env.REACT_APP_UI_URL}/samples/story/6443e21738bbc614c9b1d183`}
                            title="Sample Story"
                            width="100%" height="100%"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </InView>
            </div>
            {this.props.userStatus && !this.props.userStatus.isPremium && (
              <InView threshold={0.3} triggerOnce>
                {({ inView, ref }) => (
                  <div ref={ref} className={`text-center hp-how__subscribe hp-animate hp-animate--up delay-3 ${inView ? "is-visible" : ""}`}>
                    <Button className="hp-btn-subscribe" size="lg" onClick={this.props.openSignUpModal}>
                      Subscribe Now
                    </Button>
                    <p className="hp-how__subscribe-text">To get access to more exclusive content</p>
                  </div>
                )}
              </InView>
            )}
          </div>
          <div className="hp-wave-bottom">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
              <path fill="#fff" fillOpacity="1" d="M0,64L20,64C40,64,80,64,120,69.3C160,75,200,85,240,101.3C280,117,320,139,360,133.3C400,128,440,96,480,90.7C520,85,560,107,600,133.3C640,160,680,192,720,192C760,192,800,160,840,133.3C880,107,920,85,960,90.7C1000,96,1040,128,1080,160C1120,192,1160,224,1200,208C1240,192,1280,128,1320,106.7C1360,85,1400,107,1420,117.3L1440,128L1440,320L1420,320C1400,320,1360,320,1320,320C1280,320,1240,320,1200,320C1160,320,1120,320,1080,320C1040,320,1000,320,960,320C920,320,880,320,840,320C800,320,760,320,720,320C680,320,640,320,600,320C560,320,520,320,480,320C440,320,400,320,360,320C320,320,280,320,240,320C200,320,160,320,120,320C80,320,40,320,20,320L0,320Z" />
            </svg>
          </div>
        </section>

        {/* Story Section */}
        <section className="hp-story">
          <div className="container">
            <InView threshold={0.2} triggerOnce>
              {({ inView, ref }) => (
                <div ref={ref} className={`text-center hp-animate hp-animate--up ${inView ? "is-visible" : ""}`}>
                  <h2 className="hp-section-heading">Our Story</h2>
                  <p className="hp-story__subtitle">How MeenduToons came to life</p>
                </div>
              )}
            </InView>
            <div className="hp-story__waypoints">
              <Waypoint
                character="meendu"
                text={() => (
                  <span>
                    <strong>Founded accidentally</strong>
                    <br />
                    during a deep balcony conversation between a husband and a wife
                  </span>
                )}
              />
              <Waypoint
                character="muskaan"
                text={() => (
                  <span>
                    The conversation started with:{" "}
                    <strong>"Why were some people rude to others?"</strong>
                  </span>
                )}
                swapped
              />
              <Waypoint
                character="icy"
                text={() => (
                  <span>
                    Which left them wondering:{" "}
                    <strong>"How could we help someone be a little kind-er?"</strong>
                  </span>
                )}
              />
              <Waypoint
                character="mellow"
                text={() => (
                  <span>
                    <strong>The conclusion they reached: </strong> It's difficult
                    to change the adults, but it would comparatively be easier to
                    mould children right from the beginning
                  </span>
                )}
                swapped
              />
              <Waypoint
                character="cookie"
                text={() => (
                  <span>
                    <strong>The result: MeenduToons!</strong> A valuetainment
                    platform for kids that makes learning fun
                  </span>
                )}
              />
            </div>
            <InView threshold={0.5} triggerOnce>
              {({ inView, ref }) => (
                <div ref={ref} className={`text-center hp-story__cta hp-animate hp-animate--up ${inView ? "is-visible" : ""}`}>
                  <Button className="hp-btn-characters" variant="primary" size="lg" onClick={() => history.push("/characters")}>
                    Meet our Characters!
                  </Button>
                </div>
              )}
            </InView>
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="hp-testimonials">
          <div className="hp-wave-top">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
              <path fill="#fff" fillOpacity="1" d="M0,128L40,106.7C80,85,160,43,240,69.3C320,96,400,192,480,208C560,224,640,160,720,160C800,160,880,224,960,250.7C1040,277,1120,267,1200,224C1280,181,1360,107,1400,69.3L1440,32L1440,0L1400,0C1360,0,1280,0,1200,0C1120,0,1040,0,960,0C880,0,800,0,720,0C640,0,560,0,480,0C400,0,320,0,240,0C160,0,80,0,40,0L0,0Z" />
            </svg>
          </div>
          <div className="container">
            <InView threshold={0.2} triggerOnce>
              {({ inView, ref }) => (
                <div ref={ref} className={`hp-animate hp-animate--up ${inView ? "is-visible" : ""}`}>
                  <h2 className="hp-section-heading text-center">What Parents &amp; Kids Say</h2>
                </div>
              )}
            </InView>
            <div className="hp-testimonials__carousel">
              <Carousel indicators={false} interval={4000}>
                {testimonialsData.map((data, idx) => (
                  <Carousel.Item key={idx} className="hp-testimonial-item">
                    <div className="hp-testimonial-card">
                      <p className="hp-testimonial-quote">&ldquo;</p>
                      <p className="hp-testimonial-text">{data.text}</p>
                      <div className="hp-testimonial-identity">
                        <img
                          className="hp-testimonial-avatar"
                          width="80" height="80"
                          src={`${process.env.REACT_APP_AWS_IMG_CDN}/testimonials/${data.img}.png`}
                          alt={data.name}
                        />
                        <div>
                          <div className="hp-testimonial-name">{data.name}</div>
                          {data.subtext && <div className="hp-testimonial-subtext">{data.subtext}</div>}
                        </div>
                      </div>
                    </div>
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>
          </div>
        </section>

        {/* Footer */}

        <div className="footer-container-custom">
          {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#fff" fill-opacity="1" d="M0,96L26.7,96C53.3,96,107,96,160,101.3C213.3,107,267,117,320,112C373.3,107,427,85,480,96C533.3,107,587,149,640,154.7C693.3,160,747,128,800,128C853.3,128,907,160,960,181.3C1013.3,203,1067,213,1120,213.3C1173.3,213,1227,203,1280,176C1333.3,149,1387,107,1413,85.3L1440,64L1440,0L1413.3,0C1386.7,0,1333,0,1280,0C1226.7,0,1173,0,1120,0C1066.7,0,1013,0,960,0C906.7,0,853,0,800,0C746.7,0,693,0,640,0C586.7,0,533,0,480,0C426.7,0,373,0,320,0C266.7,0,213,0,160,0C106.7,0,53,0,27,0L0,0Z"></path></svg> */}
          <Footer />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userInfo: { ...state.checkUser?.userData },
    userStatus: state.userLoggedinAndPremiumCheck,
  };
};
export default connect(mapStateToProps, {
  checkUser,
  openSignUpModal,
  loggedInAndPremiumCheckUser,
})(HomePage);
